/* TickProtect main.js v2 — no deps. Modules map to future Shopify section behaviours. */
(function () {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Scroll reveals (staggered) */
  const io = new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { rootMargin: "0px 0px -40px 0px", threshold: 0.08 });
  $$(".reveal, .zoom").forEach((el) => {
    const sibs = el.parentElement ? [...el.parentElement.children].filter((c) => c.classList.contains("reveal")) : [];
    el.style.setProperty("--ro", Math.max(0, sibs.indexOf(el)));
    io.observe(el);
  });

  /* Header shadow + mobile nav */
  const header = $(".tp-header");
  if (header) addEventListener("scroll", () => header.classList.toggle("scrolled", scrollY > 8), { passive: true });
  const burger = $(".tp-burger"), nav = $(".tp-nav");
  if (burger && nav) burger.addEventListener("click", () => nav.classList.toggle("open"));

  /* Announcement clock = evergreen 5-hour urgency countdown. Persists per visitor and
     auto-resets to a fresh 5 hours whenever it reaches zero, so it never runs out. */
  const clock = $("#tp-clock");
  if (clock) {
    const d = clock.querySelector("[data-d]"), h = clock.querySelector("[data-h]"), m = clock.querySelector("[data-m]"), s = clock.querySelector("[data-s]");
    const SPAN = 5 * 3.6e6; // 5 hours in ms
    const KEY = "tpAnnDeadline";
    let deadline;
    try { deadline = parseInt(localStorage.getItem(KEY), 10); } catch (e) {}
    if (!deadline || isNaN(deadline) || deadline - Date.now() > SPAN) deadline = Date.now() + SPAN;
    const tick = () => {
      let l = deadline - Date.now();
      if (l <= 0) { deadline = Date.now() + SPAN; l = SPAN; } // reset — never expires
      try { localStorage.setItem(KEY, deadline); } catch (e) {}
      if (d) d.textContent = "00";
      h.textContent = String(Math.floor(l / 3.6e6)).padStart(2, "0");
      m.textContent = String(Math.floor((l % 3.6e6) / 6e4)).padStart(2, "0");
      s.textContent = String(Math.floor((l % 6e4) / 1e3)).padStart(2, "0");
    };
    tick(); setInterval(tick, 1000);
  }

  /* Dynamic delivery dates (1-3 day processing + 6-12 day transit) */
  $$("[data-deliver]").forEach((el) => {
    const f = (d) => d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
    const a = new Date(); a.setDate(a.getDate() + 7);
    const b = new Date(); b.setDate(b.getDate() + 15);
    el.textContent = f(a) + " – " + f(b);
  });
  $$("[data-today]").forEach((el) => { el.textContent = new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); });

  /* Animated counters */
  const cio = new IntersectionObserver((es) => {
    es.forEach((e) => {
      if (!e.isIntersecting) return; cio.unobserve(e.target);
      const el = e.target, t = parseFloat(el.dataset.count), suf = el.dataset.suffix || "", dur = 1500, t0 = performance.now();
      const step = (now) => { const p = Math.min(1, (now - t0) / dur), v = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(t * v).toLocaleString("en-US") + suf; if (p < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  /* Only animate the marketing stat counters. Native Shrine upsell/recommendation containers
     also carry data-count (their item count); animating their textContent wipes the rendered card. */
  $$("[data-count]").forEach((c) => { if (!c.closest('[id^="UpsellsBlock"], [class*="upsells-container"], product-info-upsell, cart-drawer-upsell, product-recommendations')) cio.observe(c); });

  /* Marquee: duplicate for seamless loop */
  $$(".tp-marquee__track").forEach((t) => { t.innerHTML += t.innerHTML; });

  /* US map tooltip */
  const tip = $(".map-tip");
  if (tip) $$(".us-state").forEach((st) => {
    st.addEventListener("mousemove", (e) => {
      const wrap = st.closest(".map-wrap").getBoundingClientRect();
      tip.style.left = (e.clientX - wrap.left) + "px";
      tip.style.top = (e.clientY - wrap.top) + "px";
      tip.textContent = st.dataset.name + (st.dataset.tip ? " — " + st.dataset.tip : "");
      tip.style.opacity = 1;
    });
    st.addEventListener("mouseleave", () => { tip.style.opacity = 0; });
  });

  /* Cart: the ATC button submits the real buy form (tp-product-buy.liquid), the header
     .tp-cart link navigates to /cart, and the count badge is server-rendered as
     {{ cart.item_count }} in tp-header.liquid. (Removed the pre-launch demo stub that
     intercepted ATC + cart clicks with e.preventDefault() and a "demo preview" toast.) */

  /* PDP gallery */
  const mainImg = $("[data-main-img]");
  if (mainImg) $$(".thumbs button").forEach((th) => th.addEventListener("click", () => {
    $$(".thumbs button").forEach((b) => b.classList.remove("active")); th.classList.add("active");
    mainImg.style.opacity = 0;
    setTimeout(() => { mainImg.src = th.querySelector("img").dataset.full || th.querySelector("img").src; mainImg.style.opacity = 1; }, 160);
  }));

  /* Colour swatches -> swap gallery */
  $$(".swatch").forEach((sw) => sw.addEventListener("click", () => {
    $$(".swatch").forEach((s) => s.classList.remove("active")); sw.classList.add("active");
    const lab = $("[data-colour]"); if (lab) lab.textContent = sw.dataset.name;
    const set = sw.dataset.gallery ? sw.dataset.gallery.split("|") : [];
    const ths = $$(".thumbs button img");
    set.forEach((src, i) => { if (ths[i]) { ths[i].src = src; ths[i].dataset.full = src; } });
    if (set[0] && mainImg) mainImg.src = set[0];
    const first = $(".thumbs button"); if (first) { $$(".thumbs button").forEach((b) => b.classList.remove("active")); first.classList.add("active"); }
  }));

  /* Size pills */
  $$(".pills .pill").forEach((p) => p.addEventListener("click", () => {
    p.parentElement.querySelectorAll(".pill").forEach((x) => x.classList.remove("active")); p.classList.add("active");
    const h = $("[data-fit]"); if (h && p.dataset.fit) h.textContent = p.dataset.fit;
  }));

  /* Quantity ladder (2x2 cards) */
  const ladder = $(".ladder");
  if (ladder) {
    const now = $("[data-now]"), was = $("[data-was]"), save = $("[data-save]");
    ladder.querySelectorAll(".ladder__card").forEach((c) => c.addEventListener("click", () => {
      if (!c.dataset.qnow) return; // skip the info card
      ladder.querySelectorAll(".ladder__card").forEach((x) => x.classList.remove("active")); c.classList.add("active");
      if (now) now.textContent = "$" + c.dataset.qnow;
      if (was) was.textContent = "$" + c.dataset.qwas;
      if (save) save.textContent = "SAVE " + c.dataset.qsave + "%";
    }));
  }

  /* Order bump (item PDPs) */
  const bump = $("[data-bump]");
  if (bump) {
    const box = bump.closest(".bump"), now = $("[data-now]"), was = $("[data-was]"), save = $("[data-save]"), atc = $("[data-atc]");
    const base = { now: now.textContent, was: was.textContent, save: save.textContent, atc: atc.textContent };
    bump.addEventListener("change", () => {
      if (bump.checked) { now.textContent = "$" + box.dataset.kitNow; was.textContent = "$" + box.dataset.kitWas; save.textContent = "SAVE " + box.dataset.kitSave + "%"; atc.textContent = "ADD FULL KIT — $" + box.dataset.kitNow; }
      else { now.textContent = base.now; was.textContent = base.was; save.textContent = base.save; atc.textContent = base.atc; }
    });
  }

  /* Sticky ATC */
  const sticky = $(".sticky-atc"), anchor = $("[data-anchor]");
  if (sticky && anchor) new IntersectionObserver((es) => {
    es.forEach((e) => sticky.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0));
  }, { threshold: 0 }).observe(anchor);
})();
